import { settleApiCall } from '../../../api/utils';
import { getModifierGroupsIds } from '../../../utils/modifierGroups';
import { createFieldToEntityMap } from '../../../utils/common';
export const getPopulatedModifierGroups = async _ref => {
  let {
    modifierGroupsClient,
    populatedModifierGroupsClient,
    items,
    populationLevel
  } = _ref;
  const shouldPopulateModifierGroups = populationLevel == null ? void 0 : populationLevel.modifierGroups;
  if (!shouldPopulateModifierGroups) {
    return {
      data: [],
      hasError: false
    };
  }
  const itemsModifierGroupIds = getModifierGroupsIds(items);
  if (itemsModifierGroupIds.length > 0) {
    const modifierGroupsApiResponse = await settleApiCall(() => modifierGroupsClient.getBulk({
      ids: itemsModifierGroupIds
    }));
    if (modifierGroupsApiResponse.hasError) {
      return modifierGroupsApiResponse;
    }
    const populateModifierGroupsResponse = await populatedModifierGroupsClient.createPopulatedModifierGroups(modifierGroupsApiResponse.data.data);
    if (populateModifierGroupsResponse.hasError) {
      return populateModifierGroupsResponse;
    }
    const populatedModifierGroupsMap = createFieldToEntityMap(populateModifierGroupsResponse.data, 'id');
    return {
      data: populateModifierGroupsResponse.data,
      idsToEntityMap: populatedModifierGroupsMap,
      hasError: false
    };
  }
  return {
    data: [],
    hasError: false
  };
};
//# sourceMappingURL=getPopulatedModifierGroups.js.map